import { render, staticRenderFns } from "./DataTextarea.vue?vue&type=template&id=84a26dda&"
import script from "./DataTextarea.vue?vue&type=script&lang=js&"
export * from "./DataTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports